<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <div v-if="!item.hidden && item.children" :key="item.id">
        <router-link
          v-if="
            hasOneShowingChildren(item.children) &&
            !item.children[0].children &&
            !item.alwaysShow
          "
          :to="item.path + '/' + item.children[0].path"
          :key="item.children[0].name"
        >
          <el-menu-item
            :index="item.path + '/' + item.children[0].path"
            :class="{ 'submenu-title-noDropdown': !isNest }"
          >
            <svg-icon
              v-if="item.children[0].meta && item.children[0].meta.icon"
              :icon-class="item.children[0].meta.icon"
            ></svg-icon>
            <span
              v-if="item.children[0].meta && item.children[0].meta.title"
              slot="title"
              >{{ item.children[0].meta.title }}</span
            >
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.name || item.path" :key="item.name">
          <template slot="title">
            <svg-icon
              v-if="item.meta && item.meta.icon"
              :icon-class="item.meta.icon"
            ></svg-icon>
            <span v-if="item.meta && item.meta.title" slot="title">{{
              item.meta.title
            }}</span>
          </template>

          <template v-for="child in item.children">
            <div v-if="!child.hidden" :key="child.id">
              <sidebar-item
                :is-nest="true"
                class="nest-menu"
                v-if="child.children && child.children.length > 0"
                :routes="[child]"
                :key="child.path"
              ></sidebar-item>

              <router-link
                v-else
                :to="item.path + '/' + child.path"
                :key="child.name"
              >
                <el-menu-item :index="item.path + '/' + child.path">
                  <svg-icon
                    v-if="child.meta && child.meta.icon"
                    :icon-class="child.meta.icon"
                  ></svg-icon>
                  <span v-if="child.meta && child.meta.title" slot="title">{{
                    child.meta.title
                  }}</span>
                </el-menu-item>
              </router-link>
            </div>
          </template>
        </el-submenu>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter((item) => {
        return !item.hidden;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scped>
/* 侧栏导航菜单经典 文字超长溢出问题 CSS折行 */
.el-submenu__title {
  display: flex;
  align-items: center;
}
.el-submenu__title span {
  white-space: normal;
  word-break: break-all;
  line-height: 20px;
  flex: 1;
  padding-right: 20px;
}

.el-menu-item {
  display: flex;
  align-items: center;
  padding-right: 20px !important;
}
.el-menu-item span {
  white-space: normal;
  word-break: break-all;
  line-height: 20px;
  flex: 1;
}
/* 动态样式 控制收起时icon图标 */
.packUp .el-submenu__title .svg-icon {
  margin-right: 0% !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue